/** Route patterns for router config */
export const onboardingRoutePatterns = {
  createProfile: '/create-profile',
} as const;

/** Full paths for navigation (navigate, Link) */
export const onboardingRoutes = onboardingRoutePatterns;
